import { render, staticRenderFns } from "./SpendingOrderList.vue?vue&type=template&id=33fb102e&scoped=true&"
import script from "./SpendingOrderList.vue?vue&type=script&lang=js&"
export * from "./SpendingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SpendingOrderList.vue?vue&type=style&index=0&id=33fb102e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb102e",
  null
  
)

export default component.exports